import JobComponent from "./components/JobComponent";
export default JobComponent;
